import { adaptFields } from '~/services/origins/contentful/adapters/adaptFields';
import { ComponentType } from '~/shared/domain/models';
import type { ContentfulStep } from '~/services/origins/contentful';
import type { StepSchema } from '~/shared/domain/models';

export const adaptSteps = (steps: ContentfulStep[] | undefined): StepSchema[] => {
  if (!steps?.length) {
    throw new Error('Missing step');
  }

  return steps.map((step) => {
    if (!step?.fields) {
      throw new Error('Missing step params');
    }

    return {
      componentType: ComponentType.Step,
      title: step.fields.title,
      subtitle: step.fields.subTitle,
      children: adaptFields(step.fields.fields),
    };
  });
};
